// removed by extract-text-webpack-plugin
module.exports = {"signup-captcha":"captcha-module__signup-captcha___2lV-7","captcha-error":"captcha-module__captcha-error___ayddO","wrapper":"captcha-module__wrapper___f_AIq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/captcha.module.scss
// module id = 276
// module chunks = 1